import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  whatsappTokenVerificationRedirectModal: {
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 'var(--ui-spacer-l)',
  },
  // qrCodeContainer: {
  //   display: 'none',
  //   maxWidth: `${theme.mediaQueries.mobile}px`,
  //   marginTop: 'var(--ui-spacer-m)',
  //   [`@media (min-width: ${theme.mediaQueries.tablet}px)`]: {
  //     display: 'flex',
  //     flexDirection: 'column',
  //     alignItems: 'center',
  //     gap: 'var(--ui-spacer-l)',
  //   },
  // },
  instructions: {
    maxWidth: `${theme.mediaQueries.mobile}px`,
    display: 'block',
    marginTop: 'var(--ui-spacer-m)',
    // [`@media (min-width: ${theme.mediaQueries.tablet}px)`]: {
    //   display: 'none',
    //   marginTop: 0,
    // },
    '& ol': {
      counterReset: 'item',
      textAlign: 'left',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'flex-start',
      gap: 'var(--ui-spacer-m)',
      '& li': {
        listStyle: 'none',
        counterIncrement: 'item',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        gap: 'var(--ui-spacer-m)',
        lineHeight: 1.5,
        marginBottom: 'var(--ui-spacer-xs)',
        '&:before': {
          content: 'counter(item)',
          display: 'flex',
          flexBasis: '2em',
          flexShrink: 0,
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          aspectRatio: '1/1',
          borderRadius: '50%',
          border: '3px solid currentColor',
          fontSize: '1em',
          lineHeight: 1,
          fontWeight: 'bold',
          transform: 'translateY(-0.3em)',
        },
        '& :first-child': {
          flex: 1,
        },
        '& img': {
          marginBottom: 0,
        },
      },
    },
  },
}))

export default useStyles
